(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      /*
      ╔══ NCJ-PATCH #44 ════════════════════════════════════════════╗
      WHAT:  ResizeObserver asíncrono para --header-height
      WHY:   Evitar el Forced Reflow síncrono en carga inicial sin alterar CLS (0% riesgo)
      RISK:  Si Dawn sobrescribe esto, regresará el diagnóstico de forced reflow de PageSpeed
      REF:   ncj-patch-index.md §44
      ╚═════════════════════════════════════════════════════════════╝
      */
      this.headerResizeObserver = new ResizeObserver(() => {
        this.setHeaderHeight();
      });
      this.headerResizeObserver.observe(this.header);
      /* ╚══ NCJ-PATCH #44 END ══╝ */

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      
      let totalHeight = headerHeight;
      
      // Dynamic sibling-traversal: Sum the heights of all active sections rendered above the header
      let sibling = this.header.previousElementSibling;
      while (sibling) {
        if (sibling.classList.contains('shopify-section')) {
          if (sibling.offsetHeight > 0 && sibling.offsetHeight < 150) {
            totalHeight += sibling.offsetHeight;
          }
        }
        sibling = sibling.previousElementSibling;
      }
      
      // Safety cap: Never let the total height exceed 250px to prevent content cropping
      if (totalHeight > 250 || totalHeight < 40) {
        totalHeight = 160; 
      }
      
      document.documentElement.style.setProperty('--total-header-height', `${totalHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      /*
      ╔══ NCJ-PATCH #44 ════════════════════════════════════════════╗
      WHAT:  Desconexión del ResizeObserver
      WHY:   Prevenir fugas de memoria (memory leaks) al desmontar el elemento
      RISK:  Fugas de memoria si el componente del header es destruido/re-renderizado
      REF:   ncj-patch-index.md §44
      ╚═════════════════════════════════════════════════════════════╝
      */
      if (this.headerResizeObserver) {
        this.headerResizeObserver.disconnect();
      }
      /* ╚══ NCJ-PATCH #44 END ══╝ */
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
